import { useState } from "react";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
import { useUrlFilterState } from "../../hooks/useUrlFilterState";
// State Import
import { useWardrobeList } from "../../state/wardrobeListState";
// Component imports
import { GenericListHeader } from "../../components/GenericHeader";
import { WardrobeTableFilterBar } from "./WardrobeTableFilterBar";
import { WardrobeTable } from "./WardrobeTable";
// MUI Imports
import Typography from "@mui/material/Typography";

export function WardrobeList() {
  // Wardrobe filter defaults
  const [wardrobeFilter, setWardrobeFilter] = useUrlFilterState({
    search: "",
    page: 1,
  });

  // List of wardrobes
  const [wardrobes, setWardrobes] = useState({ wardrobes: [], paging: {} });

  // Fetch wardrobe list using
  const { isPending, isError, data, error, isFetching, isSuccess } =
    useWardrobeList(wardrobeFilter);

  // Success Function
  const successFunc = () => setWardrobes(data.data.data.data.list);
  // Error Function
  const errorFunc = () =>
    console.warn(`Error: ${data.data.status}: ${data.data.statusText}`);
  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <>
      <GenericListHeader heading={"All Wardrobes"} />
      <WardrobeTableFilterBar
        wardrobeFilter={wardrobeFilter}
        setWardrobeFilter={setWardrobeFilter}
      />
      {isError && <Typography>Error: {error.message}</Typography>}
      <WardrobeTable
        wardrobes={wardrobes}
        loading={isFetching}
        wardrobeFilter={wardrobeFilter}
        setWardrobeFilter={setWardrobeFilter}
      />
    </>
  );
}
